export default "__VITE_ASSET__DjRLwVDq__";